import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { DataScopeModel } from 'projects/core/src/lib/models/data-scope.model';

@Component({
  selector: 'app-data-scope-detail',
  templateUrl: './data-scope-detail.component.html',
  styleUrls: ['./data-scope-detail.component.scss']
})
export class DataScopeDetailComponent extends BaseDetail implements OnInit {

  public scope: DataScopeModel = null;
  public backRoute = ['/data-scopes'];
  public liveCounts: { template?: number, businessunit?: number } = {};

  protected identifier = 'data-scope';

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        this.api.getModel('data-scopes', params.id).subscribe({
          next: (result: any) => {
            this.scope = new DataScopeModel().deserialize(result.data);
            this.scope.setTranslocoService(this.transloco);
            this.setInitialized(DetailModes.edit);
            setTimeout(() => {
              this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab-' + this.scope.id), 10);
            }, 0);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

  onTabChange(event: any): void {
    if (this.scope !== null) {
      localStorage.setItem(this.identifier + '-tab-' + this.scope.id, event.index);
    }
    this.ui.setFocus();
  }

  hasDimension(dimension: string): boolean {
    return this.scope !== null && this.scope.hasDimension(dimension);
  }

  dimensionHeader(dimension: string): string {
    const label = (dimension === 'template')
      ? this.transloco.translate('common.labels.procedures')
      : this.transloco.translate('common.labels.businessunits');
    return label + ' (' + this.entryCount(dimension) + ')';
  }

  onLiveCount(dimension: string, count: number): void {
    this.liveCounts[dimension] = count;
  }

  entryCount(dimension: string): number {
    const editKey = (dimension === 'template') ? 'templates' : 'businessunits';
    if (this.inEdit === editKey && this.liveCounts[dimension] !== undefined && this.liveCounts[dimension] !== null) {
      return this.liveCounts[dimension];
    }
    const block = (dimension === 'template') ? this.scope?.template : this.scope?.businessunit;
    if (block && Array.isArray(block.entries)) {
      return block.entries.length;
    }
    return 0;
  }

}
